import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import { LOCALSTORAGE_KEY } from "../utils/constants.js";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { formatDate } from "../utils/common-methods";
import {
  getCookie,
  CookieName,
  setCookie,
  eraseCookie
} from "../utils/cookieManager";
import Profile from "./profile";
import ReactGA from "react-ga";
import {
  setSearchQuery,
  resetStore,
  setHomeActiveMenu
} from "../actions/main.js";
import "../App.scss";
ReactGA.initialize("UA-42096921-3");

const styles = {
  selected: {
    color: "#43A64E !important",
    "&:focus": {
      outline: "none !important"
    }
  },
  title: {
    textAlign: "center",
    color: "#333"
  }
};

class SearchBox extends Component {
  constructor(props) {
    super(props);
    const activeMemu = this.props.searchQuery.activeMenu;
    if (activeMemu === null || activeMemu === "" || activeMemu === "home") {
      this.props.reset();
      eraseCookie("SearchClicked");
    }
    this.state = {
      isSnackBarOpen: false,
      isLoading: false
    };
    console.log(this.props);
    this.generateTokenFromPhonePeGrant = this.generateTokenFromPhonePeGrant.bind(
      this
    );
  }

  handleOnClick = (event, type) => {
    if (type === "source-select") {
      this.props.history.push("/select-city/source");
    } else if (type === "destination-select") {
      this.props.history.push("/select-city/destination");
    } else if (type === "doj-select") {
      const query = { type: "doj", data: event.target.value };
      this.props.setSearchQuery(query);
      window.localStorage.setItem(LOCALSTORAGE_KEY.DOJ, JSON.stringify(query));
    } else if (type === "search-buses") {
      const query = this.props.searchQuery;

      if (!query.source.city && !query.destination.city) {
        return this.openSnackBar("Please Enter Source and Destination");
      } else if (!query.source.city) {
        return this.openSnackBar("Please Enter Source ");
      } else if (!query.destination.city) {
        return this.openSnackBar("Please Enter Destination ");
      } else if (query.source.city === query.destination.city) {
        return this.openSnackBar("Source and Destination Cannot be Same!");
      }

      if (query.source.city && query.destination.city) {
        this.props.history.push(
          `/bus-booking-phonepe/from/${query.source.city}/to/${
            query.destination.city
          }/${formatDate(query.doj, "server")}`
        );
      }
    }
  };

  redirectMyTrips = () => {
    //----- phonepe sdk -------//
    this.setState({
      isLoading: true
    });
    if (getCookie(CookieName.USERTEMPTOKEN)) {
      this.props.history.push("/bus-booking-phonepe/trips");
      return;
    }

    if (!window.PhonePe) {
      const script = document.createElement("script");
      script.src = "https://www.confirmtkt.com/phonepe-js-sdk-0.3.17/bundle.js";
      script.async = true;

      script.onload = () => {
        if (!getCookie(CookieName.USERTEMPTOKEN)) {
          this.generateTokenFromPhonePeGrant().then(res => {
            this.setState({
              isLoading: false
            });
            this.props.history.push("/bus-booking-phonepe/trips");
          });
        }
      };
      document.body.appendChild(script);
    } else {
      if (!getCookie(CookieName.USERTEMPTOKEN)) {
        this.generateTokenFromPhonePeGrant().then(res => {
          this.setState({
            isLoading: false
          });
          this.props.history.push("/bus-booking-phonepe/trips");
        });
      }
    }

    //----- phonepe sdk ends -------//
  };

  swapStn = () => {
    let query;
    const s = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY)
    );
    const d = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.DESTINATION_CITY)
    );

    if (d && s) {
      query = { type: "source", data: d.data };
      this.props.setSearchQuery(query);
      window.localStorage.setItem(
        LOCALSTORAGE_KEY.SOURCE_CITY,
        JSON.stringify(query)
      );

      query = { type: "destination", data: s.data };
      this.props.setSearchQuery(query);
      window.localStorage.setItem(
        LOCALSTORAGE_KEY.DESTINATION_CITY,
        JSON.stringify(query)
      );
    } else {
      this.openSnackBar("Please Enter Source and Destination");
    }
  };

  componentDidMount() {
    const dojQuery = window.localStorage.getItem(LOCALSTORAGE_KEY.DOJ);
    if (dojQuery) {
      let today = new Date();
      let doj = JSON.parse(dojQuery);
      if (new Date(doj.data) < today) {
        const query = { type: "doj", data: formatDate(today) };
        this.props.setSearchQuery(query);
      } else {
        this.props.setSearchQuery(JSON.parse(dojQuery));
      }
    }

    const sQuery = window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY);
    if (sQuery) {
      this.props.setSearchQuery(JSON.parse(sQuery));
    }
    const dQuery = window.localStorage.getItem(
      LOCALSTORAGE_KEY.DESTINATION_CITY
    );
    if (dQuery) {
      this.props.setSearchQuery(JSON.parse(dQuery));
    }
    this.userProfileImg = getCookie(CookieName.USERIMG);
  }

  generateTokenFromPhonePeGrant = () => {
    let operatingSystem = window.PhonePe.Constants.OS.android;
    window.PhonePe.PhonePe.loggingEnabled = true;

    return window.PhonePe.PhonePe.build(
      window.PhonePe.Constants.Species.web,
      operatingSystem
    ).then(sdk => {
      sdk
        .fetchAuthToken()
        .then(res => {
          console.log("token granter");
          this.setState({ phonepeToken: res.grantToken });
          //call server side api and get confirmtkt token
          return res.grantToken;
        })
        .then(phonepeGrantToken => {
          const tokenUrl = `https://securedapi.confirmtkt.com//api/platform/authenticatephonepe?grantToken=${phonepeGrantToken}`;
          fetch(tokenUrl)
            .then(res => res.json())
            .then(res => {
              setCookie(CookieName.USERTOKEN, res.userKey, 60);
              setCookie(CookieName.USERTEMPTOKEN, res.TempToken, 60);
              setCookie(CookieName.USERNAME, res.Name, 60);
              setCookie(CookieName.USERMOBILE, res.PhoneNumber, 60);
              setCookie(CookieName.USERIMG, res.ProfileImage, 60);
              setCookie(CookieName.USEREMAIL, res.Email, 60);
              ReactGA.event({
                category: "login",
                action: "login-otp-verified-success"
              });
            });
        })
        .catch(err => {
          console.log("Error occured while fetching the grant token");
        });
    });
  };

  handleChangeMenu = (event, value) => {
    this.props.setHomeActiveMenu(value);
  };

  openSnackBar = message => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({ isSnackBarOpen: true, message: msg });
  };

  handleClose = () => {
    this.setState({ isSnackBarOpen: false });
  };

  render() {
    let dateInputSyle = {
      border: "none",
      width: "100%"
    };
    // get source n destination from local
    const q = this.props.searchQuery;
    const source =
      q && q.source.city ? (
        <span>{q.source.city}</span>
      ) : (
        <label>FROM (Ex: Bangalore)</label>
      );
    const destination =
      q && q.destination.city ? (
        <span>{q.destination.city}</span>
      ) : (
        <label>TO (Ex: Hyderabad)</label>
      );

    const otherServices = (
      <div className="other-services">
        <div>BUS SERVICES</div>
        <Card className="card-home">
          <CardContent className="card-content">
            <Grid container justify="flex-start">
              <Grid
                item
                xs={4}
                className="right-border"
                onClick={this.redirectMyTrips}
              >
                <div>
                  <i className="material-icons">directions_bus</i>
                  <br />
                  My
                  <br />
                  Bus Trips
                </div>
              </Grid>
              <Grid item xs={4} className="right-border">
                <a href="https://www.confirmtkt.com/train-booking-phonepe">
                  <i className="material-icons">train</i>
                  <br />
                  Book
                  <br />
                  Train Tickets
                </a>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );

    const homeBlock = (
      <div>
        <div className="header">
          <Grid container justify="flex-start">
            <Grid item xs={4}>
              <img
                style={{ height: "60px" }}
                src="https://www.confirmtkt.com/images/logo-white.png"
                alt="Confirmtkt"
              />
            </Grid>
            <Grid item xs={8} />
          </Grid>
        </div>
        <Card className="card-home search" /*style={styles.search} */>
          <CardHeader
            title="SEARCH BUS TICKETS"
            className="card-header"
            //classes={{ title: this.props.classes.title }}
            style={styles.title}
          />
          <CardContent className="card-content">
            <Grid container justify="flex-start">
              <Grid item xs={11}>
                <div
                  onClick={event => this.handleOnClick(event, "source-select")}
                >
                  <div className="input-field">{source}</div>
                  <hr />
                </div>

                <div
                  onClick={event =>
                    this.handleOnClick(event, "destination-select")
                  }
                >
                  <div className="input-field">{destination}</div>
                  <hr />
                </div>
              </Grid>
              <Grid item xs={1}>
                <div className="swap-container" onClick={this.swapStn}>
                  <i className="material-icons">swap_vert</i>
                </div>
              </Grid>
            </Grid>

            <div>
              <label>DEPART ON</label>
              <br />
              <span>
                <input
                  className="date-input input-field"
                  type="date"
                  id="journey-date"
                  style={dateInputSyle}
                  onChange={e => this.handleOnClick(e, "doj-select")}
                  value={this.props.searchQuery.doj}
                  min={formatDate()}
                  max={formatDate(null, "plus120Days")}
                ></input>
              </span>
              <hr />
            </div>
            <div onClick={event => this.handleOnClick(event, "search-buses")}>
              <Button variant="contained" className="ctkt-btn-success">
                BOOK TICKETS
              </Button>
            </div>
            <br />
            <div className="support">
              For booking related queries call
              <a style={{ color: "black" }} href="tel:08068243910">
                {" 08068243910 "}
              </a>
            </div>
          </CardContent>
        </Card>
        {this.state.isLoading ? (
          <div className="loading fixed">
            <CircularProgress />
          </div>
        ) : (
          ""
        )}
        {otherServices}
      </div>
    );

    let displayBlock = homeBlock;

    if (q.activeMenu === "profile") {
      displayBlock = <Profile history={this.props.history} />;
    }

    return (
      <div>
        <div className="search-home">{displayBlock}</div>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchQuery: state.searchReducer,
    trainListingReducer: state.trainListingReducer
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSearchQuery: query => {
      dispatch(setSearchQuery(query));
    },
    reset: () => {
      dispatch(resetStore());
    },
    setHomeActiveMenu: menu => {
      dispatch(setHomeActiveMenu(menu));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SearchBox));
